export default {
  guide: {
    start: 'Iniciar',
    whatsNext: 'O que vem a seguir?',
    dontShowAgain: 'Não mostrar este pop-up novamente',
    needHelp: 'Precisa de ajuda?',
    userManual: 'Manual do usuário',
    chooseFormat: 'Escolha o formato de sua preferência',
    pdfManual: 'Manual em PDF',
    downloadPdf: 'Baixar e ler offline',
    videoTutorial: 'Tutorial em vídeo',
    watchStepByStep: 'Assistir ao guia passo a passo',
    firstStepTitle: 'Bem-vindo! Vamos guiá-lo pelos seus primeiros passos.',
    activationKey: {
      title: 'As novas chaves de ativação foram registradas com sucesso.',
      description:
        'Envie as chaves de ativação aos agricultores/coletores de dados para que possam se registrar na sua organização.',
      nextStep: 'Clique no botão Ação para selecionar o formato em que deseja compartilhar as chaves.',
    },
    dashboard: {
      userManagement: 'Gestão de usuários',
      userManagementDescription: 'A seção Gestão de usuários permite que você:',
      listUser: 'Visualize a lista atual de usuários móveis e administradores',
      addUser: 'Adicione novos usuários ou convide usuários com chaves de ativação',
      managePermission: 'Gerencie permissões, planos de assinatura e funções',
      farmManagement: 'Gestão de fazendas',
      farmManagementDescription: 'Vá para a seção Gestão de fazendas para:',
      listFarm: 'Visualizar a lista de fazendas e agricultores registrados',
      addFarm: 'Adicionar novas fazendas uma a uma ou em lote',
      title: 'Painel',
      description: 'À medida que você integra mais usuários e fazendas, poderá ver o resumo no painel principal.',
    },
    ddsDashboard: {
      title: 'Comece pela seção “Criar novo relatório de diligência devida” para iniciar.',
      alreadyHaveFarm: 'Já possui dados da fazenda?',
      description:
        'Você terá a opção de adicionar os dados da sua fazenda durante a segunda etapa do processo "Criar novo relatório de diligência devida".',
      createNewReport: 'Criar novo relatório',
      creatingReport: 'Criando um relatório de diligência devida',
      sharingWithOperator: 'Compartilhando com o operador',
      riskMitigation: 'Mitigação de riscos',
    },
    productionPlace: {
      title: 'Carregue os dados da sua fazenda',
      description: 'Carregue os dados da sua fazenda um a um ou em lote clicando no botão "Adicionar novo".',
      allowedFormat: 'Atualmente, aceitamos os seguintes formatos para o envio de dados em lote:',
    },
    reportDetail: {
      title: 'Primeiro, preencha os detalhes relacionados ao seu relatório.',
      description: 'Precisa de ajuda? Consulte nossos guias do usuário (PDF ou vídeo) clicando aqui:',
      nextStep:
        'Após concluir, clique em "Próximo" para prosseguir para a etapa em que você poderá carregar os dados de produção da sua fazenda.',
    },
    adminRegistered: {
      title: 'O novo usuário administrador foi registrado com sucesso.',
      description:
        'Envie as chaves de ativação aos agricultores/coletores de dados para que possam se registrar na sua organização.',
      nextStep: 'O que vem a seguir? Comece a integrar agricultores e coletores de dados.',
    },
  },
};
